import { useRef, useEffect, useState, memo } from 'react';
import { Link } from 'gatsby';
import useObserver from '@hooks/useObserver';

interface IProps {
  post?: any;
}

function PostLink({ post }: IProps) {
  const [setNode, entry] = useObserver({});
  const [src, setSrc] = useState('');
  const targetRef = useRef(null);

  useEffect(() => {
    setNode(targetRef.current);
  }, [targetRef]);

  useEffect(() => {
    if (entry['isIntersecting'] && !src) {
      setSrc(() => post.frontmatter.cover);
    }
  }, [entry]);

  return (
    <Link to={post.frontmatter.slug}>
      <div className="post-link">
        {/* <div className="image" ref={targetRef}>
          <img src={src} alt={post.frontmatter.title} />
        </div> */}
        <div className="desc">
          <p className="category">{post.frontmatter.categories}</p>
          <h2 className="title">
            {post.frontmatter.title}
          </h2>
          <p className="created">{post.frontmatter.date}</p>
        </div>
      </div>
    </Link>
  );
}

export default memo(PostLink);
